"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _runtime = require("../runtime");
var _default = exports.default = (0, _runtime.IconWrapper)('info_normal', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("style", ['.kd-stroke-width-icon-regular{stroke-width:var(--kd-stroke-width-icon-regular, 1px); }.kd-color-icon-white{fill:#FFFFFF; fill:var(--kd-color-icon-white, #FFFFFF); stroke:#FFFFFF; stroke:var(--kd-color-icon-white, #FFFFFF); }.kd-color-icon-info{fill:#1F69E0; fill:var(--kd-color-icon-info, #1F69E0); stroke:#1F69E0; stroke:var(--kd-color-icon-info, #1F69E0); }']), h("g", {
    "class": "kd-color-icon-info kd-stroke-width-icon-regular"
  }, [h("path", {
    "attrs": {
      "d": "M8 15.9997C12.4183 15.9997 16 12.418 16 7.99973C16 3.58145 12.4183 -0.000274658 8 -0.000274658C3.58172 -0.000274658 0 3.58145 0 7.99973C0 12.418 3.58172 15.9997 8 15.9997Z",
      "stroke": "none"
    }
  })]), h("g", {
    "class": "kd-color-icon-white kd-stroke-width-icon-regular"
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 12.9997C8.55228 12.9997 9 12.552 9 11.9997V6.99973C9 6.44744 8.55228 5.99973 8 5.99973C7.44772 5.99973 7 6.44744 7 6.99973V11.9997C7 12.552 7.44772 12.9997 8 12.9997ZM7 3.99973C7 4.55201 7.44772 4.99973 8 4.99973C8.55228 4.99973 9 4.55201 9 3.99973C9 3.44744 8.55228 2.99973 8 2.99973C7.44772 2.99973 7 3.44744 7 3.99973Z",
      "stroke": "none"
    }
  })])]);
});